import { render, staticRenderFns } from "./DividerVertical.vue?vue&type=template&id=3937164c"
var script = {}
import style0 from "./DividerVertical.vue?vue&type=style&index=0&id=3937164c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports